import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  valuationGoalSelect: 'اختر هدف التقييم',
  valuationGoalIOwnProperty: 'تقييم عقار أمتلكه',
  valuationGoalCheckPrice: 'استعلام عن سعر عقار',
  valuationGoalSavedPortfolio: 'سيتم حفظ النتيجة في',
  valuationGoalSavedPortfolioWhere: '(المحفظة العقارية)',
  valuationGoalSavedMyValuations: 'سيتم حفظ النتيجة في',
  valuationGoalSavedMyValuationsWhere: '(تقييماتي)',
  locationTitle: 'موقع العقار',
  locationPlaceholder: 'الموقع',
  propertyDetailsEnter: 'ادخل تفاصيل العقار',
  propertyType: 'نوع العقار',
  propertyView: 'الإطلالة',
  propertyFinishing: 'نوع التشطيب',
  propertyArea: 'المساحة (بالمتر)',
  propertyAreaPlaceholder: 'اكتب المساحة',
  m2: 'متر² ',
  propertyRooms: 'عدد الغرف',
  propertyRoomsPlaceholder: 'اكتب العدد',
  enterNumber: 'اكتب العدد',
  propertyBathrooms: 'عدد الحمامات',
  propertyBathroomsPlaceholder: 'اكتب العدد',
  next: 'التالي',
  back: 'السابق',
  purchaseAddPrice: 'سعر شراء العقار',
  purchaseAddPricePlaceholder: 'اكتب سعر شراء عقارك',
  purchaseEnterDate: 'تاريخ شراء العقار',
  monthAndYear: ' (الشهر والسنة)',
  purchasePriceBasis:
    'سعر الشراء هو الأساس الذي يُحسب عليه العائد الاستثماري المتوقع',
  purchaseCurrentEstimate:
    'السعر الحالي من وجهة نظرك يساعدنا في مراجعة حسابات الأداة ومقارنتها بتوقعاتك',
  purchaseEnterEstimate: 'سعر العقار اليوم من وجهة نظرك',
  purchaseEnterEstimatePlaceholder: 'اكتب السعر التقريبي',
  finalAnalyzing: 'تحليل بيانات العقارات',
  finalStep: 'خطوة',
  from: ' من ',
  finalCalculate: 'احسب القيمة التقديرية',
  valuations: 'التقييمات',
  portfolio: 'المحفظة العقارية',
  valuationEmptyTitle: 'لا توجد لديك أي تقييمات سابقه',
  valuationEmptyDescription:
    'ابدا باضافة اول تقييم عقاري و اعرف سعر المتر في المناطق المهتم بها',
  addFirstValuation: 'اضف اول تقييم',
  addNewValuation: 'اضف تقييم جديد',
  portfolioEmptyTitle: 'لا توجد عقارات في محفظتك.',
  portfolioEmptyDescription:
    'ابدأ بإضافة أول عقار إلى محفظتك وتابع تطور قيمته والعائد المتوقع منه.',
  trackAvgPrice:
    'تابع متوسط سعر المتر في المناطق المهتم بها التي قيّمتها سابقًا',
  numberOfProperties: 'عدد العقارات',
  purchasePrice: 'اجمالى المحفظة',
  purchasePriceDescription:
    'هي القيمة الحالية لمجموعة العقارات بناءً علي أسعار السوق الحالية لو تم بيعها اليوم.',
  valuationPrice: 'القيمة السوقية للمحفظة',
  valuationPriceDescription:
    'قيمة المحفظة العقارية هي تكلفة شراء العقارات الأصلية وقت التملك،',
  estimatedPriceNow: 'السعر التقريبي الآن',
  moreDetails: 'المزيد من التفاصيل',
  propertyValuation: 'تقييم العقار',
  lastUpdated: 'آخر تحديث :{{date}}',
  estimationsTitle:
    'تابع متوسط سعر المتر في المناطق المهتم بيها التي قيّمتها سابقًا',
  portfolioTitle: 'نظرة شاملة على عقاراتك، و تطور قيمتها',
  purchasePriceTooltipText:
    'يساعدنا سعر الشراء في حساب العائد الاستثماري المتوقع من البيع',
  expectedValuationPriceTooltipText:
    ' السعر الحالي من وجهة نظرك بيساعدنا نراجع حسابات الأداة ونقارنها بتوقعاتك',
  valuationReport: 'تقرير التقييم',
  pound: 'جنيه',
  currentValuationSalePrice: 'السعر التقريبي للبيع الآن',
  addListing: 'اضف اعلان',
  currentValuationRentPrice: 'السعر التقريبي للإيجار الآن',
  soon: 'قريبًا',
  confidenceRate: 'دقة التقييم',
  averagePricePerMeter: 'متوسط سعر المتر',
  ROI: 'العائد الاستثماري',
  YOY: 'معدل النمو السنوي',
  relatedListingTitle: 'اعلانات ذات صلة بتقييمك',
  YOYTooltipText: '',
  ROItooltipText: '',
  purchasePriceText: 'سعر الشراء',
  purchasePriceInfoNameText:
    'هو السعر الأصلي الذي تم شراء العقار به وقت التعاقد،',
  valuationPriceText: 'القيمة الحالية',
  valuationPriceInfoNameText:
    'قيمة تقديرية للعقار، يتم احتسابها بناءً على بيانات ومؤشرات السوق، وتمثل تقديراً تقريبيًا بدقة {{confidenceRate}}%.',
  returnOnInvestment: 'نسبة العائد الاستثماري',
  returnOnInvestmentInfo:
    'هو قياس لمستوى الربحية المتحقق من العقار، ويُحسب بمقارنة سعر الشراء بالقيمة الحالية التقديرية.',
  returnOnInvestmentTitle: 'العائد الاستثماري للعقار',
  compareMarketValueTitle: 'مقارنة القيمة السوقية',
  marketAnalysisTitle: 'تحليلات السوق',
  marketSampleSize: 'حجم العينة السوقية',
  numberOfListingsAnalyzed: 'عدد الاعلانات التي تم تحليلها',
  demandIndicator: 'مستوي طلب الشراء',
  demandIndicatorLabel: 'هو مدي الاقبال علي الشراء في المنطقة',
  HIGH: 'عالي',
  MEDIUM: 'متوسط',
  LOW: 'منخفض',
  priceIndex: 'مؤشر الأسعار',
  priceIndexTooltipLabel: 'يوضح هذا المؤشر حركة سعر العقار في اخر 12 شهر.',
  yearlyChange: 'التغير السنوي في السعر',
  purchasePriceRequired: 'ادخل سعر الشراء',
  purchaseDateRequired: 'ادخل تاريخ الشراء',
  topSellersTitle: 'اكبر المكاتب العقارية',
  topSellersDescription:
    'شركات عقارية موثوقة يمكنها مساعدتك في اختيار وشراء شقة مثالية في {{location}}.',
  marketAIAnalysis: 'تحليل لحظي لبيانات السوق بالذكاء الاصطناعي',
  propertyInstantValuation: 'نتيجة فورية لتقدير سعر عقارك',
  trackDemandLevel: 'متابعة السعر التقديري لعقارك ومستوي الطلب في المنطقة',
  knowRealValue: 'اعرف القيمة الحقيقية لعقارك مع أداة تقييم العقارات',
  LUXURY: 'لوكس',
  SUPPER_LUXURY: 'سوبر لوكس',
  EXTRA_SUPER_LUXURY: 'اكسترا سوبر لوكس',
  SEMI_FINISHED: 'نصف تشطيب',
  UNFINISHED: 'بدون تشطيب',
  NILE: 'النيل',
  GOLF: 'جولف',
  LAKE: 'بحيرة',
  PLAZA: 'بلازا',
  CLUB: 'نادي',
  BACK: 'خلفي',
  GARDEN: 'حديقة',
  POOL: 'حمام سباحة',
  SEAVIEW: 'إطلالة بحر',
  CORNER: 'ناصية',
  SIDE_STREET: 'شارع جانبي',
  MAIN_STREET: 'شارع رئيسي',
  OTHER: 'أخرى',
  noValuationResultsFound: 'عفواً..لا تتوفر لدينا بيانات كافيه لهذا التقييم',
  noValuationResultsFoundDescription:
    'حاول تعديل مواصفات عقارك لتقديم تقييم دقيق وموثوق.',
  createAccount: 'إنشاء حساب',
});
